import React from 'react'

import styles from './rename.module.scss'
import { ReactComponent as XIcon } from 'assets/img/close.svg'
import ReactModal from 'react-modal';
import { useAtom } from 'jotai';
import { toast } from 'react-toastify';
import { renameTemplatePopupAtom } from 'showMessageMenuAtom';

const RenamePopup = (
    {
        IsOpen,
        setIsOpen,
        workflowTitle,
        editWorkflow,
        isEditingWorkflow,
        setWorkflowTitle,
        payload
    }:
        {
            IsOpen: boolean,
            setIsOpen: any,
            workflowTitle: any
            editWorkflow: any
            isEditingWorkflow: any
            setWorkflowTitle: any
            payload: any
        }
) => {

    const [workflowTitle3, setWorkflowTitle3] = React.useState<any>(workflowTitle)

    React.useEffect(() => {
        setWorkflowTitle3(workflowTitle)
    }, [workflowTitle && workflowTitle.length])
    const invalidAutomationTitle = (!workflowTitle3 || (workflowTitle3 && workflowTitle3.length < 3) || (workflowTitle3.length > 101))

    const closeDialog = () => {
        setWorkflowTitle3(workflowTitle)
        setIsOpen(false)
    }

    const startWorkflowCreation = () => {
        setWorkflowTitle(workflowTitle3)
        const Yespayload = { ...payload, title: workflowTitle3 };
        editWorkflow(true, Yespayload)
    }

    const [, setIsRenameTemplateOpen] = useAtom(renameTemplatePopupAtom);


    return (
        <ReactModal
            isOpen={IsOpen}
            className={styles.WorkflowPopup}
            style={{
                content: {
                    width: "480px",
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99999,
                }
            }}
        >
            <div className={styles.WorkflowPopup__header}>
                <h1>Rename workflow</h1>
                <span onClick={closeDialog}>
                    <XIcon />
                </span>
            </div>

            <div className={styles.WorkflowPopup__body}>
                <label>Name</label>
                <input
                    type='text'
                    required
                    placeholder='Enter workflow name'
                    value={workflowTitle3}
                    form-datatype='text'
                    maxLength={100}
                    onChange={e => {
                        e.preventDefault();
                        const messageData = e.target.value
                        // if page title is untitled then close rename popup
                        // and show error message
                        if (messageData === 'untitled') {
                            setIsRenameTemplateOpen(false)
                            toast('untitled is a reserved workflow name', {
                                type: 'error',
                                autoClose: 2000,
                                position: "top-center",
                                hideProgressBar: true,
                                theme: "light"
                            });
                            return;
                        }
                        if (messageData.trim() === '') {
                            setWorkflowTitle3('')
                        }
                        else {
                            if (messageData.length <= 100) {
                                setWorkflowTitle3(messageData);
                            }
                        }
                    }
                    }
                />
            </div>

            <div className={styles.WorkflowPopup__footer}>
                <button className={styles.WorkflowPopup__footer__cancel}
                    onClick={closeDialog}
                >
                    Cancel
                </button>
                <button
                    className={`
                    ${styles.WorkflowPopup__footer__create}
                     ${(invalidAutomationTitle ? `${styles.WorkflowPopup__footer__disabled}` : '')}`
                    }
                    onClick={startWorkflowCreation}
                    disabled={invalidAutomationTitle}
                >
                    {isEditingWorkflow ? 'Saving...' : 'Rename'}
                </button>
            </div>
        </ReactModal>
    )
}

export default RenamePopup
